import React from "react";

import { NorthbeamUtmPlatform } from "@features/utm-guide";

import { ConstructDestinationUrl } from "../construct-destination-url";

export const ShareASale = () => (
  <div className="flex flex-col gap-3">
    <p className="mb-0">
      You will need to add UTM parameters to all <b>destination URLs</b> for new
      and existing ads and campaigns.
    </p>
    <ConstructDestinationUrl platform={NorthbeamUtmPlatform.SHARE_A_SALE} />
    <p className="mb-0">
      Use the copied URL when creating an ad or campaign with <b>ShareASale</b>.
    </p>
  </div>
);
